<template>
  <CommonTabs
    :id="$props.id"
    resource="tariffs"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'tariffs' }"
    :breadcrumbs="breadcrumbs"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../../../components/common/tabs/CommonTabs";
import EditTariff from "../../../components/projects/accounting/tariffs/EditTariff";
import DeleteTariff from "../../../components/projects/accounting/tariffs/DeleteTariff";
import PricePerUnitTariff from "../../../components/projects/accounting/tariffs/PricePerUnitTariff";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
export default {
  name: "Tariff",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      EditTariff,
      PricePerUnitTariff,
      DeleteTariff
    },
    tabs: [
      {
        component: "EditTariff",
        title: "edit"
      },
      {
        component: "PricePerUnitTariff",
        title: "price-per-unit",
        tabClass: { "tab-item-full-width": true, "tab-item-padding-0": true }
      },
      {
        component: "DeleteTariff",
        title: "delete"
      }
    ]
  }),
  computed: {
    tariff: {
      get() {
        return this.$store.getters["projectMeteringStore/tariffStore/getItem"];
      }
    },
    breadcrumbs() {
      return this.tariff.id
        ? [
            {
              text: this.$t("tariffs.tariffs"),
              to: {
                name: "tariffs",
                params: {
                  project_id: this.$props.project_id
                }
              },
              exact: true
            },
            {
              text: this.tariff.name,
              to: {
                name: "tariff",
                params: {
                  project_id: this.$props.project_id,
                  id: this.tariff.id
                }
              },
              exact: true
            }
          ]
        : [];
    }
  },
  watch: {
    tariff: function() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("tariffs.tariffs"), this.tariff.name] };
    }
  },
  mounted() {
    this.$store.dispatch("projectMeteringStore/tariffStore/get", {
      id: this.$props.id,
      project_id: this.$props.project_id
    });
  }
};
</script>
